export const technologyServices = [
  {
    title: "Chatbot Development",
    description: "Automate conversations, enhance customer experience, and scale operations with intelligent AI-powered chatbots.",
    categories: [
      {
        name: "AI Chatbot Solutions",
        items: ["Custom chatbots for websites, apps, and social platforms", "NLP-based conversational flows", "Multilingual chatbot development", "CRM and API integrations", "Secure and scalable architecture"]
      },
      {
        name: "Business Automation Chatbots",
        items: ["Sales, booking, and appointment bots", "Customer support and FAQ automation", "WhatsApp, Messenger, Telegram bots", "Workflow and trigger-based automation", "Compliance-ready systems"]
      },
      {
        name: "AI Sales & Lead Generation Bots",
        items: ["Lead capture and qualification", "Automated sales funnels", "Personalized recommendations", "Email and CRM integration", "Conversion-focused conversation design"]
      },
      {
        name: "Internal & Support Bots",
        items: ["HR and onboarding chatbots", "IT helpdesk and ticketing bots", "Internal knowledge base bots", "Role-based access", "Performance analytics"]
      }
    ]
  },
  {
    title: "Website Development",
    description: "High-performance, SEO-friendly, and conversion-focused websites built to grow your business.",
    categories: [
      {
        name: "Custom Website Development",
        items: ["Corporate, startup, and business websites", "Responsive UI/UX design", "SEO-friendly architecture", "CMS (WordPress, Webflow, Headless CMS)", "Cross-device compatibility"]
      },
      {
        name: "E-commerce & Web Portals",
        items: ["Custom eCommerce platforms", "Secure payment integrations", "Product and inventory management", "Admin dashboards", "Scalable infrastructure"]
      },
      {
        name: "Landing Pages & Funnels",
        items: ["High-converting landing pages", "Funnel-based user journeys", "A/B testing", "CRM and ad integrations", "CRO optimization"]
      },
      {
        name: "Website Maintenance",
        items: ["Regular updates and backups", "Speed optimization", "Security monitoring", "Content updates", "Ongoing technical support"]
      }
    ]
  },
  {
    title: "App Development",
    description: "Powerful mobile applications designed for performance, usability, and scalability.",
    categories: [
      {
        name: "Mobile App Development",
        items: ["Android and iOS apps", "Native and cross-platform solutions", "UI/UX-focused design", "API and third-party integrations", "App store deployment"]
      },
      {
        name: "Startup & Enterprise Apps",
        items: ["MVP development", "Business productivity apps", "Real-time analytics", "Secure user authentication", "Long-term support"]
      },
      {
        name: "UI/UX Design & Prototyping",
        items: ["Wireframing and user journeys", "Interactive prototypes", "Usability testing", "Brand-consistent design", "Accessibility-focused UX"]
      },
      {
        name: "App Maintenance",
        items: ["Bug fixes and updates", "Feature enhancements", "OS compatibility updates", "User analytics", "Dedicated support teams"]
      }
    ]
  },
  {
    title: "Search Engine Optimization (SEO)",
    description: "Increase visibility, rankings, and organic traffic with proven SEO strategies.",
    categories: [
      {
        name: "On-Page & Technical SEO",
        items: ["Keyword research and audits", "On-page optimization", "Core Web Vitals optimization", "Mobile SEO", "Internal linking"]
      },
      {
        name: "Off-Page SEO",
        items: ["High-quality backlink building", "Outreach and digital PR", "Authority growth strategies", "Monthly reporting", "White-hat practices"]
      },
      {
        name: "Content SEO",
        items: ["Blog planning and execution", "Topic clusters and pillar pages", "Search intent optimization", "AI-assisted + human editing", "Performance tracking"]
      },
      {
        name: "Local & International SEO",
        items: ["Google Maps optimization", "Citation management", "Multi-language SEO", "Country-specific targeting", "International site structuring"]
      }
    ]
  },
  {
    title: "YouTube & TikTok Automation",
    description: "End-to-end video automation systems that grow and monetize channels.",
    categories: [
      {
        name: "Channel Automation",
        items: ["Niche research", "Scriptwriting", "Voice-over and editing", "SEO-optimized uploads", "Scheduled publishing"]
      },
      {
        name: "Short-Form Video Growth",
        items: ["Reels, TikToks, Shorts", "Trend and hashtag research", "AI-assisted creation", "Monetization strategies", "Multi-platform scaling"]
      },
      {
        name: "Monetization & Scaling",
        items: ["AdSense optimization", "Affiliate and sponsorship setup", "Digital product monetization", "Brand collaborations", "Channel expansion"]
      },
      {
        name: "Analytics & Optimization",
        items: ["Audience retention analysis", "CTR optimization", "Thumbnail and hook testing", "Performance dashboards", "Continuous growth refinement"]
      }
    ]
  },
  {
    title: "AI Business Consulting",
    description: "Leverage AI to reduce costs, automate operations, and unlock growth.",
    categories: [
      {
        name: "AI Strategy & Consulting",
        items: ["AI readiness assessments", "Custom AI roadmaps", "Process automation", "Predictive analytics", "Compliance and governance"]
      },
      {
        name: "AI Integration & Training",
        items: ["AI tool selection", "Custom AI agents", "Team training", "BI dashboards", "Continuous optimization"]
      },
      {
        name: "AI Automation",
        items: ["Workflow automation", "Customer service AI", "Scheduling and operations AI", "Document processing", "System integrations"]
      },
      {
        name: "AI Product Development",
        items: ["AI SaaS consulting", "MVP development", "Recommendation engines", "Predictive systems", "Long-term AI roadmap"]
      }
    ]
  },
  {
    title: "Custom Software Development",
    description: "Tailor-made software solutions built to solve complex business challenges.",
    categories: [
      {
        name: "Bespoke Software",
        items: ["Web and desktop applications", "ERP and CRM systems", "SaaS platforms", "Secure architecture", "API-first development"]
      },
      {
        name: "Enterprise Development",
        items: ["Agile project management", "Dedicated teams", "QA and security audits", "Maintenance and upgrades", "IP protection"]
      },
      {
        name: "Cloud & DevOps",
        items: ["Cloud-native apps", "AWS, Azure, GCP", "CI/CD pipelines", "Infrastructure automation", "Scalable deployments"]
      },
      {
        name: "Testing & QA",
        items: ["Manual and automated testing", "Performance testing", "Security audits", "Bug tracking", "Compliance assurance"]
      }
    ]
  }
];

export const businessServices = [
  {
    title: "Accounting & Finance",
    description: "Accurate, compliant, and insight-driven financial management.",
    categories: [
      {
        name: "Bookkeeping & Ledger Management",
        items: ["Transaction recording", "Ledger maintenance", "Bank reconciliations", "AP/AR tracking", "Monthly closings"]
      },
      {
        name: "Financial Reporting & Analysis",
        items: ["Balance Sheet, P&L, Cash Flow", "Budgeting and forecasting", "Variance analysis", "KPI dashboards", "Management reporting"]
      },
      {
        name: "Tax Planning & Compliance",
        items: ["Strategic tax planning", "Business tax filings", "Audit support", "Local & international compliance"]
      },
      {
        name: "Payroll Processing",
        items: ["Payroll calculations", "Payslips and portals", "Statutory deductions", "Direct deposits", "Year-end forms"]
      }
    ]
  },
  {
    title: "Social Media Management",
    description: "Strategic content, consistent branding, and measurable growth.",
    categories: [
      {
        name: "Content Creation & Scheduling",
        items: ["Graphics, reels, videos", "Content calendars", "Captions, hashtags, CTAs", "Platform optimization", "Stories and carousels"]
      },
      {
        name: "Account Setup & Optimization",
        items: ["Bio and profile optimization", "Branding alignment", "Highlight covers", "Link-in-bio setup", "Competitor analysis"]
      },
      {
        name: "Growth & Engagement",
        items: ["Organic growth strategies", "Community management", "Influencer collaborations", "Engagement tracking", "Performance reports"]
      },
      {
        name: "Paid Advertising",
        items: ["Facebook, Instagram, LinkedIn ads", "Audience targeting", "Creative design", "A/B testing", "Conversion tracking"]
      }
    ]
  },
  {
    title: "Poster & Video Creation",
    description: "High-impact visual content that captures attention and converts.",
    categories: [
      {
        name: "Poster Design",
        items: ["Event and promo posters", "Business flyers", "Brand-consistent designs", "Print and digital formats", "Unlimited revisions"]
      },
      {
        name: "Social Media Videos",
        items: ["Reels, TikToks, Shorts", "Product and promo videos", "Motion graphics", "Transitions and music", "Text overlays"]
      },
      {
        name: "Business Videos",
        items: ["Explainers and intros", "Testimonials", "Event recaps", "Animation and voiceovers"]
      },
      {
        name: "Video Editing",
        items: ["Trimming and color correction", "Subtitles and overlays", "Multi-format delivery", "Optimized exports", "Quality assurance"]
      }
    ]
  },
  {
    title: "Sales & Lead Generation",
    description: "Data-driven lead generation and conversion systems.",
    categories: [
      {
        name: "Lead Generation (B2B & B2C)",
        items: ["Targeted lead lists", "Email, phone, social data", "LinkedIn prospecting", "Lead qualification", "CRM-ready delivery"]
      },
      {
        name: "Outreach & Follow-ups",
        items: ["Email, LinkedIn, WhatsApp campaigns", "Custom copywriting", "Automated sequences", "Inbox monitoring", "A/B testing"]
      },
      {
        name: "Sales Funnel Setup",
        items: ["Funnel strategy", "Landing pages", "CRM integration", "Lead nurturing", "Analytics tracking"]
      },
      {
        name: "Cold Calling & Appointments",
        items: ["Trained callers", "Appointment setting", "Calendar management", "Script preparation", "Performance reporting"]
      }
    ]
  },
  {
    title: "Content Writing & Blogging",
    description: "SEO-focused, brand-aligned content that builds authority and drives conversions.",
    categories: [
      {
        name: "Blog Writing",
        items: ["SEO long & short-form blogs", "Keyword research", "Original content", "Internal & external linking", "Meta optimization"]
      },
      {
        name: "Website Content",
        items: ["Homepage and service pages", "Clear CTAs", "Brand voice alignment", "Mobile optimization", "Conversion-focused copy"]
      },
      {
        name: "Product Descriptions",
        items: ["Feature-benefit copy", "SEO optimization", "Audience-specific tone", "Scannable formatting", "Category descriptions"]
      },
      {
        name: "Ghostwriting",
        items: ["LinkedIn articles", "eBooks", "Thought leadership", "Confidential writing", "Publishing-ready formats"]
      }
    ]
  },
  {
    title: "MS Office & Excel Solutions",
    description: "Smart automation, analysis, and reporting with Office tools.",
    categories: [
      {
        name: "Custom Excel Templates",
        items: ["Invoices and trackers", "Dashboards", "Financial models", "Data validation", "Professional formatting"]
      },
      {
        name: "Data Analysis & Visualization",
        items: ["PivotTables & charts", "KPI dashboards", "Forecasting", "Trend analysis", "Excel & PowerPoint reports"]
      },
      {
        name: "Excel Automation",
        items: ["VBA macros", "Task automation", "Report generation", "Data imports", "Debugging"]
      },
      {
        name: "Office Integration",
        items: ["Mail merges", "Excel-to-Word/PowerPoint", "Outlook automation", "Cross-platform workflows"]
      }
    ]
  },
  {
    title: "Customer Support",
    description: "Reliable, professional, and multi-channel customer support.",
    categories: [
      {
        name: "Multi-Channel Support",
        items: ["Email and live chat", "Social media", "WhatsApp & Messenger", "Ticketing systems", "Seamless handovers"]
      },
      {
        name: "Order & Inquiry Handling",
        items: ["Order tracking", "Issue resolution", "Refunds and exchanges", "Feedback collection", "Response templates"]
      },
      {
        name: "Technical Support",
        items: ["Knowledge base updates", "Troubleshooting", "Documentation", "Internal coordination", "User-friendly responses"]
      },
      {
        name: "Virtual Assistant Support",
        items: ["Email and calendar management", "CRM updates", "Data entry", "Reports", "Admin support"]
      }
    ]
  },
  {
    title: "Truck Dispatching & Trucking Services",
    description: "24/7 dispatching support for owner-operators and fleets.",
    categories: [
      {
        name: "Dispatching Support",
        items: ["Load planning", "Rate negotiation", "Paperwork handling", "Driver communication", "Dedicated dispatchers"]
      },
      {
        name: "Load Booking",
        items: ["DAT, TruckStop access", "All equipment types", "No forced dispatch", "Reduced deadhead", "Load reports"]
      },
      {
        name: "Compliance & Documentation",
        items: ["Carrier setup", "IFTA support", "Insurance certificates", "HOS assistance", "Record keeping"]
      },
      {
        name: "Billing & Invoicing",
        items: ["Broker invoicing", "POD management", "Payment follow-ups", "Factoring coordination", "Payment tracking"]
      }
    ]
  },
  {
    title: "Medical Billing Services",
    description: "Accurate, compliant, and revenue-focused medical billing.",
    categories: [
      {
        name: "Revenue Cycle Management",
        items: ["Patient registration", "Charge entry", "Claim submission", "Payment posting", "AR follow-ups"]
      },
      {
        name: "Insurance Verification",
        items: ["Eligibility checks", "Pre-authorizations", "Copay verification", "Front desk updates", "Audit documentation"]
      },
      {
        name: "Medical Coding & Compliance",
        items: ["CPT, ICD-10, HCPCS coding", "Specialty-specific coding", "HIPAA compliance", "Code audits", "Clean claim submission"]
      },
      {
        name: "Claims & Denial Management",
        items: ["Claim resubmissions", "Appeals", "ERA/EOB reconciliation", "Aging reports", "Denial reduction strategies"]
      }
    ]
  }
];

export const industries = [
  { name: "Communications", icon: "📡", desc: "Empowering digital connectivity and customer engagement." },
  { name: "Banking & Financial Services", icon: "🏦", desc: "Secure, compliant, and scalable financial solutions." },
  { name: "Public Sector", icon: "🏛️", desc: "Driving efficiency, transparency, and digital governance." },
  { name: "Healthcare", icon: "🏥", desc: "Technology-driven healthcare operations and patient care." },
  { name: "Retail", icon: "🛍️", desc: "Enhancing customer experiences and retail operations." },
  { name: "Autotech", icon: "🚗", desc: "Smart mobility and automotive innovation." },
  { name: "FinTech", icon: "💳", desc: "Next-generation financial technology solutions." },
  { name: "FoodTech", icon: "🍔", desc: "Technology that powers modern food businesses." },
  { name: "Construction", icon: "🏗️", desc: "Digitizing construction operations and project management." },
  { name: "Education", icon: "📚", desc: "Empowering learning through technology." },
  { name: "Logistics", icon: "🚚", desc: "Streamlined logistics and supply chain solutions." },
  { name: "E-Commerce", icon: "🛒", desc: "Scalable digital commerce solutions." },
  { name: "SaaS & Startups", icon: "🚀", desc: "Helping startups scale with confidence." },
  { name: "Manufacturing", icon: "🏭", desc: "Operational efficiency through smart technology." }
];

export const methodology = {
  title: "Our Methodology",
  description: "We use Scrum and Agile practices to deliver high-quality, scalable solutions. Short iterations, continuous feedback, and cross-functional collaboration keep projects on track and aligned with your goals.",
  steps: [
    { name: "Sprint Planning", desc: "We agree on sprint goals and select backlog items as a team. Priorities are set collaboratively so every iteration delivers the highest value." },
    { name: "Daily Stand-ups", desc: "Short, focused syncs to share progress, blockers, and next steps. Keeps the team aligned and surfaces issues early." },
    { name: "Sprint Review & Demo", desc: "We demo working increments to stakeholders and gather feedback. Done work is shown in a real environment so you see progress every sprint." },
    { name: "Retrospectives", desc: "After each sprint we reflect on what went well and what to improve. Process and quality get better over time." },
    { name: "Backlog Refinement", desc: "We keep the product backlog ordered and ready. Stories are clarified, estimated, and broken down so development stays smooth." },
    { name: "Incremental Delivery", desc: "We ship in small, shippable increments. You get working software often, with the option to release at the end of any sprint." },
    { name: "Scrum Roles & Ceremonies", desc: "Clear roles (Product Owner, Scrum Master, Dev Team), time-boxed ceremonies, and visible artifacts (board, burndown) so everyone knows the status." }
  ]
};

export type IndustryModalId = 'fintech' | 'autotech' | 'foodtech' | 'healthcare' | 'construction';

export const industryModalContent: Record<IndustryModalId, { title: string; icon: string; overview: string; howWeHelp: string[] }> = {
  fintech: {
    title: "FinTech",
    icon: "💳",
    overview: "The financial technology sector is transforming how people and businesses manage money, from digital payments and lending to wealth management and regulatory tech. FinTech companies need secure, compliant, and scalable solutions that can integrate with existing financial systems and meet strict regulatory requirements.",
    howWeHelp: [
      "Custom software and web apps for payments, dashboards, and client portals",
      "AI chatbots and automation for customer support and lead qualification",
      "Accounting, bookkeeping, and financial reporting to keep your back office in order",
      "Secure, scalable architecture and integrations with banks and payment providers",
      "SEO and digital presence so your FinTech product is discoverable and trusted"
    ]
  },
  autotech: {
    title: "AutoTech",
    icon: "🚗",
    overview: "AutoTech covers everything from vehicle marketplaces and fleet management to EV solutions, connected cars, and mobility apps. The industry is moving toward digital-first experiences, data-driven operations, and seamless online-to-offline journeys for buyers and operators.",
    howWeHelp: [
      "Web and mobile apps for car marketplaces, booking, inspections, and lead capture",
      "Custom software for fleet management, dispatching, and logistics",
      "Chatbots and automation for inquiries, appointments, and follow-ups",
      "Data analytics, Excel solutions, and reporting for operations and sales",
      "SEO and content to drive traffic and conversions in a competitive market"
    ]
  },
  foodtech: {
    title: "FoodTech",
    icon: "🍔",
    overview: "FoodTech includes delivery platforms, restaurant management systems, cloud kitchens, and food-related e-commerce. Success depends on smooth ordering, reliable operations, and strong visibility online—all while managing high volume and tight margins.",
    howWeHelp: [
      "Websites, ordering systems, and mobile apps for restaurants and delivery brands",
      "Social media management and video content to build and engage your audience",
      "Lead generation and sales outreach for B2B food and F&B suppliers",
      "Customer support and order handling so your team can focus on operations",
      "Accounting, invoicing, and reporting tailored to F&B and delivery businesses"
    ]
  },
  healthcare: {
    title: "Healthcare",
    icon: "🏥",
    overview: "Healthcare providers and health-tech companies need solutions that are secure, compliant, and built for patient care and operational efficiency. From clinics and telehealth to medical billing and health apps, the sector demands reliability and clear compliance with regulations.",
    howWeHelp: [
      "Web and app development for patient portals, booking, and telehealth experiences",
      "Medical billing services, revenue cycle support, and insurance verification",
      "AI chatbots for appointment scheduling, FAQs, and triage",
      "Customer support and back-office automation so staff can focus on patients",
      "Secure, scalable systems and integrations with existing practice management tools"
    ]
  },
  construction: {
    title: "Construction",
    icon: "🏗️",
    overview: "Construction and trades are digitizing project management, workforce scheduling, procurement, and client communication. Companies that adopt the right tools can reduce delays, control costs, and improve safety and compliance.",
    howWeHelp: [
      "Custom software for project management, scheduling, and resource allocation",
      "Websites and portals for tenders, documentation, and client communication",
      "Lead generation and outreach to win new projects and partnerships",
      "Excel and Power BI solutions for costing, reporting, and dashboards",
      "Accounting, payroll, and compliance support for contractors and subcontractors"
    ]
  }
};

